import request from '@/utils/request'

// 获取过磅列表
export function getList(params) {
  return request.post('/weighbridge/list', params).then(({ data }) => {
    const { msg, data: queryData, code } = data
    const { records, total } = queryData
    return { data: { msg, data: { items: records, total }, code } }
  })
}

// 骨料水份检测
export function updateOne(data) {
  return request.post('/weighbridge/moistureDetection', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
